"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var typeTemplate = '${label} is not a valid ${type}';
var common = {
  reset: 'Reset',
  cancel: 'Cancel',
  confirm: 'OK',
  noData: 'No data',
  noSearchResult: 'No search results'
};
var _default = exports.default = {
  AutoComplete: {
    placeholder: 'Select',
    noData: 'No data'
  },
  FileInput: {
    placeholder: 'Select file',
    remove: 'Remove',
    choice: 'Choose'
  },
  Upload: {
    defaultError: 'upload fail'
  },
  ImageUpload: {
    upload: 'Upload',
    uploadAgain: 'Upload again'
  },
  Loading: {
    text: 'Loading'
  },
  Modal: {
    openText: 'OK',
    closeText: 'Cancel'
  },
  Select: {
    placeholder: 'Select',
    noData: 'No data',
    noChoice: 'No option',
    columnSet: 'column set',
    columnShow: 'column show',
    reset: 'reset',
    fixedColumn: 'fixed column',
    fixedLeft: 'fixed left',
    fixedRight: 'fixed right',
    fixedCancel: 'fixed cancel',
    etc: 'etc',
    indivual: ''
  },
  Cascader: {
    noData: 'No data',
    noMatch: 'No matching data'
  },
  Mark: {
    texts: ['Terrible', 'Down', 'Normal', 'Good', 'Surprise']
  },
  DatePicker: {
    monthText: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    quarter: ['Q1', 'Q2', 'Q3', 'Q4'],
    halfYear: ['H1', 'H2'],
    daysText: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    placeholder: 'Select Time',
    selectStartPlaceholder: 'Start Time',
    selectEndPlaceholder: 'End Time',
    selectMonthText: 'Select Month',
    selectYearText: 'Select Year',
    week: 'Week',
    dayjsLocal: 'en'
  },
  ImageView: {
    zoomIn: 'Enlarge',
    zoomOut: 'Narrow',
    prev: 'Previous',
    next: 'Next',
    rotateLeft: 'Rotate',
    reset: 'Reset',
    close: 'Close',
    noData: 'No Picture Data',
    download: 'DownLoad',
    rotateY: 'Flip Horizontal'
  },
  Pagination: {
    itemsPerPage: '/ page',
    jumpTo: 'Go to',
    jump: 'Jump',
    page: 'Page'
  },
  Table: {
    filterSearchPlaceholder: 'Search Filter Items ',
    filterReset: 'Reset',
    filterConfirm: 'OK',
    filterEmptyText: 'No filters',
    filterCheckall: 'Select all items',
    filterCheckNotall: 'Select none items',
    noData: 'No Data',
    triggerDesc: 'Click to sort descending',
    triggerAsc: 'Click to sort ascending',
    cancelSort: 'Click to cancel sorting',
    columnSet: 'Column Settings',
    columnShow: 'Column presentation',
    columnReset: 'Reset',
    fixedColumn: 'Fix the column',
    fixedLeft: 'Fixed left side',
    fixedRight: 'Fixed right side',
    fixedCancel: 'Unpin',
    fixedForbid: 'Fixed column not operable'
  },
  MultiCascader: {
    placeholder: 'Select',
    checkAll: 'Select All Data',
    searchPlaceholder: 'Search',
    noResultsText: 'No Data',
    checkAllButtonText: 'Select All',
    noData: 'No Data'
  },
  TreeSelect: {
    searchPlaceholder: 'Search',
    noData: 'No Data'
  },
  Form: {
    optional: '(optional)'
  },
  FormPro: {
    optional: '(optional)',
    defaultValidateMessages: {
      default: 'Field validation error for ${label}',
      required: 'Please enter ${label}',
      enum: '${label} must be one of [${enum}]',
      whitespace: '${label} cannot be a blank character',
      date: {
        format: '${label} date format is invalid',
        parse: '${label} cannot be converted to a date',
        invalid: '${label} is an invalid date'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label} must be ${len} characters',
        min: '${label} must be at least ${min} characters',
        max: '${label} must be up to ${max} characters',
        range: '${label} must be between ${min}-${max} characters'
      },
      number: {
        len: '${label} must be equal to ${len}',
        min: '${label} must be minimum ${min}',
        max: '${label} must be maximum ${max}',
        range: '${label} must be between ${min}-${max}'
      },
      array: {
        len: 'Must be ${len} ${label}',
        min: 'At least ${min} ${label}',
        max: 'At most ${max} ${label}',
        range: 'The amount of ${label} must be between ${min}-${max}'
      },
      pattern: {
        mismatch: '${label} does not match the pattern ${pattern}'
      }
    }
  },
  ImageEdit: (0, _assign.default)((0, _assign.default)({}, common), {
    replace: 'Replace',
    imageUpload: 'Upload image',
    picturePreview: 'Picture preview',
    imgClearVisible: '※ Please make sure the image is clearly visible',
    imgScale: 'Picture ratio',
    zoomIn: 'Enlarge',
    zoomOut: 'Narrow',
    rotateLeft: 'Rotate',
    cropSize: 'Current size: '
  }),
  Empty: {
    text: common.noData
  },
  LineFold: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  OrganizationPicker: (0, _assign.default)((0, _assign.default)({}, common), {
    prompt: 'prompt',
    fail: 'fetch failed',
    chosen: 'You have chosen',
    items: 'items',
    click: 'Click to view',
    org: 'Organizational structure',
    chose: 'Choose organizational structure',
    search: 'Search organizational structure',
    pleaseChose: 'Please search',
    searchContent: 'Search content',
    loading: 'loading',
    chosenItems: 'Selected',
    empty: 'empty',
    city: 'City',
    cityGroup: 'CityGroup'
  }),
  Evaluation: {
    title: 'Did the above functions help you?',
    likeDesc: 'This is great, I like it!',
    dislikeDesc: 'Not satisfied. please continue optimizing...',
    feedbackDesc: 'Send Feedback'
  },
  MultiTableSelector: (0, _assign.default)((0, _assign.default)({}, common), {
    rightText: 'Selected data',
    labelText: 'Please enter',
    search: 'Search'
  }),
  MultiTabSelector: (0, _assign.default)((0, _assign.default)({}, common), {
    maxSelected: 'At most',
    ge: '',
    choose: 'Selected data',
    empty: 'Empty',
    chooseAll: 'Select all',
    labelText: 'Please enter',
    confirmEmpty: 'Are you sure to clear'
  }),
  CountDown: {
    confirm: 'ok',
    second: 's'
  },
  DateSelect: {
    customBtnText: "custom",
    leftRadioText: ['Yesterday', 'Last 7 days', 'Last 30 days', 'This month'],
    DefaultRightSelectorText: ['By day', 'By week', 'By month']
  },
  DynamicForm: {
    newData: "New content",
    clearData: "Fill all the content",
    delete: "delete",
    copy: "copy",
    down: "Sequentially down",
    up: "Order upward",
    max: "Most can be added",
    item: "item",
    clearGroup: "Removal group"
  },
  MisSearch: {
    noSearchResult: common.noSearchResult
  }
};